export async function api<T = any>(
  path: string,
  opts: { method?: string; body?: any; query?: Record<string, string> } = {}
): Promise<T> {
  const method = opts.method || 'GET'
  const qs = opts.query
    ? '?' + new URLSearchParams(opts.query).toString()
    : ''
  const res = await fetch(`/api${path}${qs}`, {
    method,
    credentials: 'include',
    headers: opts.body ? { 'Content-Type': 'application/json' } : undefined,
    body: opts.body ? JSON.stringify(opts.body) : undefined,
  })
  const text = await res.text()
  let data: any = null
  try {
    data = text ? JSON.parse(text) : null
  } catch {
    data = { error: text }
  }
  if (!res.ok) {
    const message = data?.error || `Erreur ${res.status}`
    throw Object.assign(new Error(message), { status: res.status, data })
  }
  return data as T
}
